import {
  Component,
  ElementRef,
  computed,
  effect,
  inject,
  input,
  output,
  viewChild
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFileDownload, faPrint } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'wf-pdf-preview',
  standalone: true,
  imports: [
    FontAwesomeModule,
    FontAwesomeModule
  ],
  templateUrl: './pdf-preview.component.html',
  styleUrls: ['../../../core/styles/dialog.css', './pdf-preview.component.css'],
})
export class PdfPreviewComponent {
  private readonly domSanitizer = inject(DomSanitizer);
  printIcon = faPrint;
  downloadIcon = faFileDownload;
  isOpen = input<boolean>(false);
  pdfUrl = input<string | null>(null);
  fileName = input<string>('report-pdf.pdf');
  onClose = output<void>();

  dialogElement = viewChild<ElementRef<HTMLDialogElement>>('pdfDialog');
  iframe = viewChild<ElementRef<HTMLIFrameElement>>('pdfFrame');

  constructor() {
    effect(() => {
      const dialog = this.dialogElement()?.nativeElement;
      if (!dialog) return;

      if (this.isOpen()) {
        dialog.showModal();
      } else {
        dialog.close();
      }
    });
  }

  safePdfUrl = computed(() => {
    const url = this.pdfUrl();
    return url ? this.domSanitizer.bypassSecurityTrustResourceUrl(url) : null ;
  });

  print() {
    const iframeEl = this.iframe()?.nativeElement;

    if (iframeEl?.contentWindow) {
      iframeEl.contentWindow.focus();
      iframeEl.contentWindow.print();
    }
  }

  download() {
    if (this.pdfUrl()) {
      const a = document.createElement('a');
      a.href = this.pdfUrl()!;
      a.download = this.fileName();
      a.click();
    }
  }

  handleClose() {
    this.onClose.emit();
  }
}
